<template>
  <div>
    <vxe-grid
      ref="vxegrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      show-footer
      keep-source
      :seq-config="{}"
      :editConfig="{
        trigger: 'click',
        mode: 'column',
      }"
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { default: null, type: Object },
    loading: { default: false },
    shipmentStatus: { type: String },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns.map(
        (t) => totalColumnValues[t.field] || ''
      )
      result[0] = '合计'

      return [result]
    },
  },
  methods: {
    changeDeclarationAmount(data) {
      if (data instanceof Object) {
        data = { changeList: [data] }
      } else if (data instanceof Array) {
        data = { changeList: data }
      }
      this.$api.shipmentChangeDeclarationAmount(data).then((res) => {
        const { status } = res
        if (status != 200) {
          this.$message.error('更新报关金额失败')
          return
        }
        this.$emit('reload')
      })
    },
  },
}
</script>
